// Create customized loaders here: https://skeletonreact.com/
import ContentLoader, { Facebook } from 'react-content-loader'

export const Loader = (props) => <ContentLoader uniqueKey="Loader" className="m-3" {...props} />
export const FacebookLoader = (props) => (
  <div className="p-3 bg-white rounded">
    <Facebook uniqueKey="FacebookLoader" {...props} />
  </div>
)

// TODO: make this extend to full main screen width?
const makeLoaderFn =
  (uniqueKey, children, opts = {}) =>
  (props) =>
    (
      <ContentLoader
        speed={2}
        width={opts.width || 600}
        height={opts.height || 100}
        viewBox={`0 0 ${opts.width || 600} ${opts.height || 100}`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        uniqueKey={uniqueKey}
        {...props}
      >
        {children}
      </ContentLoader>
    )

export const BlockLoader = makeLoaderFn(
  'BlockLoader',
  <>
    <rect x="5" y="15" rx="3" ry="3" width="100" height="75" />
    <rect x="125" y="15" rx="3" ry="3" width="100" height="75" />
    <rect x="245" y="15" rx="3" ry="3" width="100" height="75" />
    <rect x="365" y="15" rx="3" ry="3" width="100" height="75" />
  </>,
)

// TODO: not currently used -- remove if we don't start using soon
const SideTabsLoader = makeLoaderFn(
  'SideTabsLoader',
  <>
    <circle cx="10" cy="20" r="8" />
    <rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
    <circle cx="10" cy="50" r="8" />
    <rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
    <circle cx="10" cy="80" r="8" />
    <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />

    <rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
    <rect x="290" y="16" rx="5" ry="5" width="250" height="20" />
    <rect x="290" y="49" rx="5" ry="5" width="250" height="40" />
  </>,
)

export const CardListLoader = makeLoaderFn(
  'CardListLoader',
  <>
    <rect x="4" y="8" rx="3" ry="3" width="8" height="317" />
    <rect x="7" y="317" rx="3" ry="3" width="669" height="8" />
    <rect x="669" y="9" rx="3" ry="3" width="7" height="313" />
    <rect x="5" y="8" rx="3" ry="3" width="669" height="7" />
    <rect x="114" y="52" rx="6" ry="6" width="483" height="15" />
    <circle cx="77" cy="60" r="15" />
    <rect x="116" y="105" rx="6" ry="6" width="420" height="15" />
    <circle cx="78" cy="113" r="15" />
    <rect x="115" y="158" rx="6" ry="6" width="483" height="15" />
    <circle cx="78" cy="166" r="15" />
    <rect x="117" y="211" rx="6" ry="6" width="444" height="15" />
    <circle cx="79" cy="219" r="15" />
    <rect x="117" y="263" rx="6" ry="6" width="483" height="15" />
    <circle cx="80" cy="271" r="15" />
  </>,
  {
    width: 750,
    height: 350,
  },
)
